var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportLocalCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 473 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4230_31057)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.560547,
    width: 473,
    height: 473,
    rx: 236.5,
    fill: "url(#paint0_radial_4230_31057)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.560547,
    width: 502.479,
    height: 502.479,
    fill: "url(#pattern0_4230_31057)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4230_31057",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4230_31057",
    transform: "scale(0.000244141)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4230_31057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.771 334.206) rotate(-58.9774) scale(223.594 293.128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222D43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4230_31057"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.560547,
    width: 473,
    height: 473,
    rx: 236.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportLocalCircle);
export default __webpack_public_path__ + "static/media/support_local_circle.54eba91c2005ee640eea0251e7b9ad0f.svg";
export { ForwardRef as ReactComponent };